import { render, staticRenderFns } from "./PageWechatBind.vue?vue&type=template&id=0725ccc7&scoped=true"
import script from "./PageWechatBind.vue?vue&type=script&lang=js"
export * from "./PageWechatBind.vue?vue&type=script&lang=js"
import style0 from "./PageWechatBind.vue?vue&type=style&index=0&id=0725ccc7&prod&lang=scss&scoped=true"
import style1 from "./PageWechatBind.vue?vue&type=style&index=1&id=0725ccc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0725ccc7",
  null
  
)

export default component.exports